import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import classes from "./TaggableInputField.scss";
import { MentionsInput, Mention } from "./MentionLibrary";
import { _getTriggerRegex } from "./MentionLibrary/MentionsInput";
import { colors } from "Constants";
import { Avatar } from "@toddle-edu/ds-web";
import { getAvatarColor } from "Utils";
import I18nHOC from "UIComponents/I18nHOC";
import {
  getFormattedUserName,
  getUserIdentifierName,
} from "Utils/GetFormattedUserName";

class TaggableInputField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSuggestions: false,
      atIndex: -1,
      setCursorAtEnd: false,
      enabled: false,
    };
  }

  onEnterPress = e => {
    if (this.props.onEnterPress) this.props.onEnterPress(e);
  };

  addOthers = () => {
    let value = this.props.value;
    const regEx = _getTriggerRegex("@", { allowSpaceInQuery: true });

    let shouldAddAt = false;

    if (value && value.length > 0 && value[value.length - 1] !== "@") {
      shouldAddAt = true;
    } else if (_.isEmpty(value)) {
      shouldAddAt = true;
    }

    if (shouldAddAt) {
      value = _.isEmpty(value) ? "@" : `${value} @`;
      this.setState({ value });
      this.updateLocalComment(value);
    }

    // if (!value.match(regEx)) {

    // }

    if (this.inputRef) {
      this.inputRef.focus();
    }
  };

  removeFocus = () => {
    if (this.inputRef && this.inputRef.blur) {
      this.inputRef.blur();
    }
  };

  matchRegex = value => {
    //match regex for @
    const escapeRegex = str => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    const escapedTriggerChar = escapeRegex("@");
    // const reg = new RegExp(
    //   `(?:^|\\s)(${escapedTriggerChar}([^${
    //     true ? "" : "\\s"
    //   }${escapedTriggerChar}]*))$`
    // );
    const reg = new RegExp(`(@([a-zA-z]+[ ]*[a-zA-Z]*)*)+`);
    return value ? value.replace("&nbsp;", "").match(reg) : null;
  };

  updateLocalComment = param => {
    const { name, updateInputField } = this.props;
    if (updateInputField) {
      if (name) {
        updateInputField({ [name]: param });
      } else {
        updateInputField(param);
      }
    }
  };

  renderSuggestions = (
    item,
    search,
    highlightedDisplay,
    index,
    focused,
    testId
  ) => {
    // console.log(item, search, highlightedDisplay, index, focused);

    const iconType = item.iconType ? item.iconType : undefined;

    const avatarColor = item.color ? item.color : getAvatarColor(item?.id);

    return (
      <div
        // onClick={() => this.onItemClicked(item)}
        data-test-id={`${testId}-${item?.id}`}
        className={classes.listItemContainer}
        style={{ backgroundColor: focused ? colors.strokeOne : "white" }}
      >
        <div className={classes.profileImage}>
          <Avatar
            src={item?.profileImage}
            name={getUserIdentifierName({ user: item })}
            size={"small"}
            shape={"circle"}
            id={item?.id}
            shade={"dark"}
            iconType={iconType}
            color={avatarColor}
          />
        </div>
        <div className="text-body-2">{highlightedDisplay}</div>
      </div>
    );
  };

  handleChange = e => {
    this.updateLocalComment(e.target.value);
  };

  handleKeyDown = e => {
    const { allowSubmitOnEnter, allowSubmitOnCmdEnter } = this.props;

    const shouldHandleEnterPress =
      (e.keyCode === 13 && allowSubmitOnEnter) ||
      (e.keyCode === 13 && (e.metaKey || e.ctrlKey) && allowSubmitOnCmdEnter);

    if (shouldHandleEnterPress) {
      e.preventDefault();
      this.updateLocalComment(e.target.value);
      this.onEnterPress(e);
    }
  };

  render() {
    const {
      props: {
        value,
        collaborators,
        parentNode,
        disableTagging,
        userInfo,
        showProfileAvatar,
        mentionInputConStyle,
        t,
        onBlur,
        commentContainerRef,
        placeholder,
        textAreaStyle,
        highlighterContainerStyle,

        controlContainerStyle,

        onPaste,

        textAreaInputRef,
        minRows,
        maxRows,
        textAreaStyles,
        suggestionsOverlayStyle,
        testId,
      },
      state: { showSuggestions, enabled },
    } = this;

    return (
      <div className={classes.container}>
        <MentionsInput
          inputRef={ref => (this.inputRef = ref)}
          allowSpaceInQuery={true}
          value={value}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          parentNode={parentNode}
          commentContainerRef={commentContainerRef}
          disableTagging={disableTagging}
          userInfo={userInfo}
          showProfileAvatar={showProfileAvatar}
          mentionInputConStyle={mentionInputConStyle}
          onBlur={onBlur}
          placeholder={placeholder}
          textAreaStyle={textAreaStyle}
          highlighterContainerStyle={highlighterContainerStyle}
          controlContainerStyle={controlContainerStyle}
          textAreaInputRef={textAreaInputRef}
          minRows={minRows}
          onPaste={onPaste}
          maxRows={maxRows}
          suggestionsOverlayStyle={suggestionsOverlayStyle}
          textAreaStyles={textAreaStyles}
          testId={`${testId}-taggableInputField`}
        >
          <Mention
            trigger="@"
            data={_.map(collaborators, item => {
              const display =
                item.firstName === "common:all"
                  ? t(item.firstName)
                  : getFormattedUserName({
                      user: item,
                    });
              return { ...item, display: _.trim(display) };
            })}
            renderSuggestion={this.renderSuggestions}
            style={{ backgroundColor: "#E6E6E8" }}
            appendSpaceOnAdd={true}
          />
        </MentionsInput>
      </div>
    );
  }
}

TaggableInputField.defaultProps = {
  disableTagging: false,
  allowSubmitOnEnter: false,
  allowSubmitOnCmdEnter: false,
  testId: "UIComponents",
};

TaggableInputField.propTypes = {
  disableTagging: PropTypes.bool,
  allowSubmitOnCmdEnter: PropTypes.bool,
  allowSubmitOnEnter: PropTypes.bool,
  testId: PropTypes.string,
};

export default I18nHOC({ resource: ["common"] })(TaggableInputField);
